$('.card__link').on('click', function(e){
	Cookies.set('backHistory','true',{expires: 1});
});

$('main.details .btn--back').on('click', function(e){
	e.preventDefault();
	var backHistoryVal = Cookies.get('backHistory');
	if (backHistoryVal === 'true' || backHistoryVal === true) {
		if (history.length > 1) {
			Cookies.set('backHistory','false',{expires: 1});
			history.back();
		} else {
			Cookies.set('backHistory','false',{expires: 1});
			window.location = $(this).attr('href');
		}
	} else {
		Cookies.set('backHistory','false',{expires: 1});
		window.location = $(this).attr('href');
	}
});